import { Card } from '@repo/ui/Card';

export interface SubAccountReadOnlyViewProps {
  name: string;
  notes?: string;
}

const SubAccountReadOnlyView = ({ name, notes }: SubAccountReadOnlyViewProps) => {
  return (
    <Card title="Sub Account Details">
      <div className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium text-grey-700 dark:text-grey-300">Name</label>
          <p className="mt-1 text-grey-900 dark:text-grey-100">{name}</p>
        </div>
        {notes && (
          <div>
            <label className="block text-sm font-medium text-grey-700 dark:text-grey-300">
              Description
            </label>
            <p className="mt-1 text-grey-900 dark:text-grey-100 whitespace-pre-wrap">{notes}</p>
          </div>
        )}
      </div>
    </Card>
  );
};

export default SubAccountReadOnlyView;
